import { ReactNode } from 'react';
import { MaterialSymbol, BodyText, withStyles } from 'vopay';
import styles from './InfoBanner.module.scss';

const cn = withStyles(styles);

export type InfoBannerProps = {
  children: ReactNode;
};

export default function InfoBanner({ children }: InfoBannerProps) {
  return (
    <div className={cn('banner')}>
      <MaterialSymbol icon="info" size="20px" color="var(--vopayBlue)" fillAmount={1} />
      <BodyText size="sm" className={cn('bannerText')}>
        {children}
      </BodyText>
    </div>
  );
}
